import React, { useContext } from 'react';

import { useNewRelicBrowserAgent } from '@notino/react-observability';

import { NEW_RELIC_OWNER } from '../../constants';
import { ErrorContext } from '../../ErrorContext';
import { ELogLevel } from '../../logger';

interface Props {
  children: React.ReactNode;
}

class InnerErrorBoundary extends React.PureComponent<{
  children: React.ReactNode;
  onError: (error: Error, info: React.ErrorInfo) => void;
}> {
  public componentDidCatch(error: Error, info: React.ErrorInfo): void {
    this.props.onError(error, info);
  }

  public render(): React.ReactNode {
    return this.props.children;
  }
}

const ErrorBoundary: React.FC<Props> = ({ children }) => {
  const errorContext = useContext(ErrorContext);
  const agent = useNewRelicBrowserAgent();

  const handleError = (error: Error, info: React.ErrorInfo): void => {
    if (errorContext) {
      errorContext.callLogger({ logLevel: ELogLevel.ERROR, logError: error });
      errorContext.setFatalError(true);
    }
    if (agent) {
      agent.noticeError(error, {
        componentStack: info.componentStack,
        owner: NEW_RELIC_OWNER,
      });
    }
  };

  return <InnerErrorBoundary onError={handleError}>{children}</InnerErrorBoundary>;
};

export default ErrorBoundary;
